export const avDataEntryInitialState = {
    guid: '',
    status: 'idle',
    updateStatus: 'idle',
    refresh: false,
    updateEpisodeListStatus: { updateEpisodeListStatus: 'idle' },
    isNewProgramme: false,
    isNewEpisode: false,
    showDataUpdate: false,
    showDataCreate: false,
    dataUpdateKey: 0,
    showEpisodeDataUpdate: false,
    showEpisodeDataCreate: false,
    episodeDataUpdateKey: 0,
    areProgrammeLanguagesInvalid: [],
    areProgrammeTitlesInvalid: [],
    programmeTitles: [],
    programmePrimaryTitle: '',
    isPrimaryTitleInvalid: false,
    areEpisodeLanguagesInvalid: [],
    areEpisodeTitlesInvalid: [],
    episodeTitles: [],
    episodeListEditRowCount: 0,
    contributionEditRowCount: 0,
    sort: null,
    filter: null,
    isEpisodeSaveAndExitClicked: false,
    episodeListCurrentPage: 1,
    episodeListFirst: 0,
    episodeListRows: 10,
    episodeListTotalPages: 0,
    episodeListFetchStatus: { status: 'idle' },
    episodeListPageData: null,
}

export const avDataEntryReducer = (state = avDataEntryInitialState, action) => {
    switch (action.type) {
        case 'DATAENTRY_AUDIOVISUAL_SET_FETCH_STATUS_ACTION':
            return {
                ...state,
                status: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_CREATE_STATUS_ACTION':
            return {
                ...state,
                status: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_FETCH_RESULT_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid], // Preserve existing properties
                    original: action.payload // Replace original with new payload
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_PROGRAMME_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    original: action.payload
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_EPISODES_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    original: {
                        ...(state[state.guid]?.original || {}),
                        episodes: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_NEW_PROGRAMME_ACTION':
            return {
                ...state,
                isNewProgramme: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_NEW_EPISODE_ACTION':
            return {
                ...state,
                isNewEpisode: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_VERSION_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    original: {
                        ...(state[state.guid]?.original || {}),
                        version: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMME_UPDATE_AUDITDATA_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    original: {
                        ...(state[state.guid]?.original || {}),
                        updatedBy: action.payload.name,
                        updatedOn: action.payload.date
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMME_CREATE_AUDITDATA_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    original: {
                        ...(state[state.guid]?.original || {}),
                        createdOn: action.payload.date,
                        createdBy: action.payload.name,
                        updatedBy: action.payload.name,
                        updatedOn: action.payload.date
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        ...action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_TITLES_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        titles: action.payload
                    },
                    original: state[state.guid]?.original // To preserve the original property
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_TITLES_ACTION':
            {
                const { titles, ...draftWithoutTitles } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutTitles
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_ISRADIO_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        isRadio: action.payload,
                        animeOrLive:
                            !action.payload && // Check if isRadio is false
                                !state[state.guid]?.draft?.animeOrLive && // Check if draft animeOrLive is empty
                                !state[state.guid]?.original?.animeOrLive // Check if original animeOrLive is empty
                                ? 'LI' // Default to 'LI'
                                : state[state.guid]?.draft?.animeOrLive || state[state.guid]?.original?.animeOrLive // Preserve existing value
                    }
                }
            }    
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_MASTERIDA_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        idAid: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_ANIME_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        animeOrLive: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_LANGUAGE_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        languageId: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_PROGRAMMETYPE_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        programmeTypeId: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_FORMATTYPE_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        formatId: action.payload
                    }
                }
            }

        case 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_RESULT_SAPCODE_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    original: {
                        ...(state[state.guid]?.original || {}),
                        sapCode: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_ORIGINAL_RESULT_SAPCODE_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...(state[state.guid]?.episode || {}),
                        original: {
                            ...(state[state.guid]?.episode?.original || {}),
                            sapCode: action.payload.episodeSapCode,
                            programmeSapCode: action.payload.programmeSapCode
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_UPDATE_AUDITDATA_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        original: {
                            ...(state[state.guid]?.episode?.original || {}),
                            updatedBy: action.payload.name,
                            updatedOn: action.payload.date
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_CREATE_AUDITDATA_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        original: {
                            ...(state[state.guid]?.episode?.original || {}),
                            createdOn: action.payload.date,
                            createdBy: action.payload.name,
                            updatedBy: action.payload.name,
                            updatedOn: action.payload.date
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_PRODUCTIONCOMPANIES_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        productionCompanies: {
                            ...(state[state.guid]?.draft?.productionCompanies || {}),
                            ...action.payload
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_COUNTRY_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        countries: {
                            ...(state[state.guid]?.draft?.countries || {}),
                            ...action.payload
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_EPISODES_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    draft: {
                        ...(state[state.guid]?.draft || {}),
                        episodes: {
                            ...(state[state.guid]?.draft?.episodes || {}),
                            ...action.payload
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_ACTION':
            {
                const {
                    draft,
                    ...stateWithoutDraft
                } = state[state.guid] || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...stateWithoutDraft
                    }
                }
            }                     
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_PROGRAMMETYPE_ACTION':
            {
                const {
                    programmeTypeId,
                    ...draftWithoutProgrammeTypeId
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutProgrammeTypeId
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_FORMATTYPE_ACTION':
            {
                const {
                    formatId,
                    ...draftWithoutFormatId
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutFormatId
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_ISRADIO_ACTION':
            {
                const {
                    isRadio,
                    ...draftWithoutIsRadio
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutIsRadio
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_MASTERIDA_ACTION':
            {
                const {
                    idAid,
                    ...draftWithoutidAid
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutidAid
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_ANIME_ACTION':
            {
                const {
                    animeOrLive,
                    ...draftWithoutAnime
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutAnime
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_LANGUAGE_ACTION':
            {
                const {
                    languageId,
                    ...draftWithoutLanguage
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutLanguage
                    }
                }
            }

        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_PRODUCTIONCOMPANIES_ACTION':
            {
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: {
                            ...(state[state.guid]?.draft || {}),
                            productionCompanies: {
                                ...(state[state.guid]?.draft?.productionCompanies || {}),
                                ...(Array.isArray(action.payload) ? action.payload.reduce((acc, companyId) => {
                                    acc[companyId] = {
                                        ...(state[state.guid]?.draft?.productionCompanies?.[companyId] || {}),
                                        isDeleted: true
                                    };
                                    return acc;
                                }, {}) : {
                                    [action.payload]: {
                                        ...(state[state.guid]?.draft?.productionCompanies?.[action.payload] || {}),
                                        isDeleted: true
                                    }
                                })
                            }
                        }
                    }
                }
            }

        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_COUNTRY_ACTION':
            {
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: {
                            ...(state[state.guid]?.draft || {}),
                            countries: {
                                ...(state[state.guid]?.draft?.countries || {}),
                                ...(Array.isArray(action.payload) ? action.payload.reduce((acc, countryId) => {
                                    acc[countryId] = {
                                        ...(state[state.guid]?.draft?.countries?.[countryId] || {}),
                                        isDeleted: true
                                    };
                                    return acc;
                                }, {}) : {
                                    [action.payload]: {
                                        ...(state[state.guid]?.draft?.countries?.[action.payload] || {}),
                                        isDeleted: true
                                    }
                                })
                            }
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_EPISODES_ACTION':
            {
                const {
                    draft,
                    ...episodeWithoutDraft
                } = state[state.guid]?.episode || {};

                const isSaveComplete = action.payload?.isSaveComplete || false
                const original = episodeWithoutDraft.original

                // Only filter deleted items after save (not on cancel)
                // On cancel: just discard draft, keep original intact
                // On save: filter out deleted items since latestEpisodeData contains isDeleted flags
                if (isSaveComplete && draft && original) {
                    // Filter out deleted contributions
                    if (draft.contributions) {
                        const filteredContributions = Object.entries(original.contributions || {})
                            .filter(([key]) => !draft.contributions[key]?.isDeleted)
                            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
                        episodeWithoutDraft.original = {
                            ...original,
                            contributions: filteredContributions
                        }
                    }
                    // Filter out deleted transmissions
                    if (draft.transmissions) {
                        const filteredTransmissions = Object.entries(episodeWithoutDraft.original.transmissions || {})
                            .filter(([key]) => !draft.transmissions[key]?.isDeleted)
                            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
                        episodeWithoutDraft.original = {
                            ...episodeWithoutDraft.original,
                            transmissions: filteredTransmissions
                        }
                    }
                }

                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: episodeWithoutDraft
                    },
                    contributionEditRowCount: 0
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_EPISODES_LIST_ACTION':
            {
                const {
                    episodes,
                    ...draftWithoutepisodes
                } = state[state.guid]?.draft || {}
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        draft: draftWithoutepisodes
                    }
                }

            }
        case 'DATAENTRY_AUDIOVISUAL_SET_GUID':
            return {
                ...state,
                guid: action.payload,
                episodeListPageData: null,
                episodeListCurrentPage: 1,
                episodeListFirst: 0,
                episodeListFetchStatus: { status: 'idle' },
            }
        case 'DATAENTRY_AUDIOVISUAL_CLEAR_GUID':
            return {
                ...state,
                guid: ''
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODEFETCH_STATUS_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        status: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODEUPDATE_STATUS_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        status: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_SAVE_AND_EXIT_CLICKED_ACTION':
            return {
                ...state,
                isEpisodeSaveAndExitClicked: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODELISTUPDATE_STATUS_ACTION':
            return {
                ...state,
                updateEpisodeListStatus: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODEFETCH_RESULT_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        original: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODEGUID':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        guid: action.payload
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_CLEAR_EPISODE_RESULTS_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {}
                },
                contributionEditRowCount: 0
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_RESULT_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            ...action.payload
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_TRANSMISSIONS_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            transmissions: {
                                ...(state[state.guid]?.episode?.draft?.transmissions || {}),
                                ...action.payload
                            }
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_RESULT_TITLE_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            titles: action.payload
                        }
                    }



                }
            }

        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_TRANSMISSIONS_ACTION':
            {
                const originalTransmissions = state[state.guid]?.episode?.original?.transmissions || {}
                const draftTransmissions = { ...state[state.guid]?.episode?.draft?.transmissions }

                // Check if the transmission exists in the original data
                if (originalTransmissions[action.payload]) {
                    // If it exists in the original, mark it with isDeleted flag
                    draftTransmissions[action.payload] = { isDeleted: true }
                } else {
                    // If it does not exist in the original, remove it from the draft
                    delete draftTransmissions[action.payload]
                }

                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: {
                            ...state[state.guid]?.episode,
                            draft: {
                                ...(state[state.guid]?.episode?.draft || {}),
                                transmissions: draftTransmissions
                            }
                        }
                    }
                }
            }

        case 'DATAENTRY_AUDIOVISUAL_DELETE_EPISODE_DRAFT_RESULT_TITLE_ACTION':
            {
                const titles = { ...state[state.guid]?.episode?.draft?.titles }
                if (!titles[action.payload]) {
                    titles[action.payload] = { isDeleted: true };
                } else {
                    titles[action.payload].isDeleted = true;
                }

                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: {
                            ...state[state.guid]?.episode,
                            draft: {
                                ...(state[state.guid]?.episode?.draft || {}),
                                titles: titles
                            }
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMMEUPDATE_STATUS_ACTION':
            return {
                ...state,
                updateStatus: action.payload
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_DURATION_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            durationMinutes: action.payload

                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_DURATION_ACTION':
            {
                const draftCopy = { ...state[state.guid]?.episode?.draft }
                delete draftCopy.durationMinutes;

                /* Check if draftCopy is empty*/
                const isDraftEmpty = Object.keys(draftCopy).length === 0

                const newEpisode = {
                    ...state[state.guid]?.episode,
                    draft: isDraftEmpty ? undefined : draftCopy
                }
                if (isDraftEmpty) {
                    delete newEpisode.draft;
                }
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: newEpisode
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_YEAR_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            yearOfProduction: action.payload

                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_YEAR_ACTION':
            {
                const draftCopy = { ...state[state.guid]?.episode?.draft }
                delete draftCopy.yearOfProduction

                /* Check if draftCopy is empty*/
                const isDraftEmpty = Object.keys(draftCopy).length === 0

                const newEpisode = {
                    ...state[state.guid]?.episode,
                    draft: isDraftEmpty ? undefined : draftCopy
                }
                if (isDraftEmpty) {
                    delete newEpisode.draft;
                }
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: newEpisode
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_IDA_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            idaCode: action.payload

                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_IDA_ACTION':
            {
                const draftCopy = { ...state[state.guid]?.episode?.draft }
                delete draftCopy.idaCode

                /* Check if draftCopy is empty*/
                const isDraftEmpty = Object.keys(draftCopy).length === 0

                const newEpisode = {
                    ...state[state.guid]?.episode,
                    draft: isDraftEmpty ? undefined : draftCopy
                }
                if (isDraftEmpty) {
                    delete newEpisode.draft;
                }
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: newEpisode
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_SERIES_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            series: action.payload

                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_SERIES_ACTION':
            {
                const draftCopy = { ...state[state.guid]?.episode?.draft }
                delete draftCopy.series

                /* Check if draftCopy is empty*/
                const isDraftEmpty = Object.keys(draftCopy).length === 0

                const newEpisode = {
                    ...state[state.guid]?.episode,
                    draft: isDraftEmpty ? undefined : draftCopy
                }
                if (isDraftEmpty) {
                    delete newEpisode.draft;
                }
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: newEpisode
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_NUMBER_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            number: action.payload

                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_NUMBER_ACTION':
            {
                const draftCopy = { ...state[state.guid]?.episode?.draft }
                delete draftCopy.number

                /* Check if draftCopy is empty*/
                const isDraftEmpty = Object.keys(draftCopy).length === 0

                const newEpisode = {
                    ...state[state.guid]?.episode,
                    draft: isDraftEmpty ? undefined : draftCopy
                }
                if (isDraftEmpty) {
                    delete newEpisode.draft;
                }
                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: newEpisode
                    }
                }
            }

        case 'DATAENTRY_AUDIOVISUAL_UNDO_DELETE_DRAFT_TRANSMISSIONS_ACTION': {
            const draftCopy = { ...state[state.guid]?.episode?.draft }
            const draftTransmissions = draftCopy?.transmissions || {}

            if (draftTransmissions[action.payload]) {
                // Delete the transmission 
                delete draftTransmissions[action.payload]
            }

            const isTransmissionsListEmpty = Object.keys(draftTransmissions).length === 0

            // Before checking the length of draftCopy, ensure to delete the transmissions node if it's an empty object
            if (isTransmissionsListEmpty) {
                delete draftCopy.transmissions
            }

            const isDraftEmpty = Object.keys(draftCopy).length === 0

            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: isDraftEmpty ? undefined : {
                            ...(state[state.guid]?.episode?.draft || {}),
                            transmissions: isTransmissionsListEmpty ? undefined : draftTransmissions
                        }
                    }
                }
            }
        }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_EPISODE_DRAFT_TRANSMISSION_ACTION': {

            const draftCopy = { ...state[state.guid]?.episode?.draft }
            delete draftCopy.transmissions;

            const isDraftEmpty = Object.keys(draftCopy).length === 0
            const newEpisode = {
                ...state[state.guid]?.episode,
                draft: isDraftEmpty ? undefined : draftCopy
            }
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: newEpisode
                }
            }
        }
        case 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_CONTRIBUTIONS_ACTION':
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: {
                        ...state[state.guid]?.episode,
                        draft: {
                            ...(state[state.guid]?.episode?.draft || {}),
                            contributions: {
                                ...(state[state.guid]?.episode?.draft?.contributions || {}),
                                ...action.payload
                            }
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_CONTRIBUTIONS_ACTION':
            {
                const originalContributions = state[state.guid]?.episode?.original?.contributions || {}
                const draftContributions = { ...state[state.guid]?.episode?.draft?.contributions }

                // Check if the contribution exists in the original data
                // Handle both array and object formats for original contributions
                const id = action.payload
                const existsInOriginal = Array.isArray(originalContributions)
                    ? originalContributions.some(c => c.id === id)
                    : (originalContributions[id] !== undefined)

                if (existsInOriginal) {
                    // If it exists in the original, mark it with a delete tag
                    draftContributions[id] = { isDeleted: true }
                } else {
                    // If it does not exist in the original, remove it from the draft
                    delete draftContributions[id]
                }

                return {
                    ...state,
                    [state.guid]: {
                        ...state[state.guid],
                        episode: {
                            ...state[state.guid]?.episode,
                            draft: {
                                ...(state[state.guid]?.episode?.draft || {}),
                                contributions: draftContributions
                            }
                        }
                    }
                }
            }
        case 'DATAENTRY_AUDIOVISUAL_UNDO_DELETE_DRAFT_CONTRIBUTIONS_ACTION': {
            const draftCopy = { ...state[state.guid]?.episode?.draft }
            const draftContributions = draftCopy?.contributions || {}

            if (draftContributions[action.payload]) {
                // Delete the contribution
                delete draftContributions[action.payload]
            }

            const isContributionsListEmpty = Object.keys(draftContributions).length === 0

            // Before checking the length of draftCopy, ensure to delete the contributions node if it's an empty object
            if (isContributionsListEmpty) {
                delete draftCopy.contributions
            }

            const isDraftEmpty = Object.keys(draftCopy).length === 0
            const newEpisode = {
                ...state[state.guid]?.episode,
                draft: isDraftEmpty ? undefined : {
                    ...(state[state.guid]?.episode?.draft || {}),
                    contributions: isContributionsListEmpty ? undefined : draftContributions
                }
            }
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: newEpisode
                }
            }
        }
        case 'DATAENTRY_AUDIOVISUAL_DELETE_EPISODE_DRAFT_CONTRIBUTION_ACTION': {

            const draftCopy = { ...state[state.guid]?.episode?.draft }
            delete draftCopy.contributions;

            const isDraftEmpty = Object.keys(draftCopy).length === 0
            const newEpisode = {
                ...state[state.guid]?.episode,
                draft: isDraftEmpty ? undefined : draftCopy
            }
            return {
                ...state,
                [state.guid]: {
                    ...state[state.guid],
                    episode: newEpisode
                }
            }
        }
        case 'DATAENTRY_SET_SHOW_DATA_UPDATE': {
            return {
                ...state,
                showDataUpdate: action.payload,
            }
        }
        case 'DATAENTRY_SET_SHOW_DATA_CREATE': {
            return {
                ...state,
                showDataCreate: action.payload,
            }
        }
        case 'DATAENTRY_SET_DATA_UPDATE_KEY': {
            return {
                ...state,
                dataUpdateKey: action.payload,
            }
        }
        case 'DATAENTRY_SET_SHOW_EPISODE_DATA_UPDATE': {
            return {
                ...state,
                showEpisodeDataUpdate: action.payload,
            }
        }
        case 'DATAENTRY_SET_SHOW_EPISODE_DATA_CREATE': {
            return {
                ...state,
                showEpisodeDataCreate: action.payload,
            }
        }
        case 'DATAENTRY_SET_EPISODE_DATA_UPDATE_KEY': {
            return {
                ...state,
                episodeDataUpdateKey : action.payload,
            }
        }
        case 'DATAENTRY_SET_ARE_EPISODE_LANGUAGES_INVALID': {
            return {
                ...state,
                areEpisodeLanguagesInvalid: action.payload,
            }
        }
        case 'DATAENTRY_SET_ARE_EPISODE_TITLES_INVALID': {
            return {
                ...state,
                areEpisodeTitlesInvalid: action.payload,
            }
        }
        case 'DATAENTRY_SET_EPISODE_TITLES': {
            return {
                ...state,
                episodeTitles: action.payload,
            }
        }
        case 'DATAENTRY_SET_ARE_PROGRAMME_LANGUAGES_INVALID': {
            return {
                ...state,
                areProgrammeLanguagesInvalid: action.payload,
            }
        }
        case 'DATAENTRY_SET_ARE_PROGRAMME_TITLES_INVALID': {
            return {
                ...state,
                areProgrammeTitlesInvalid: action.payload,
            }
        }
        case 'DATAENTRY_SET_PROGRAMME_TITLES': {
            return {
                ...state,
                programmeTitles: action.payload,
            }
        }
        case 'DATAENTRY_SET_PROGRAMME_PRIMARY_TITLE': {
            return {
                ...state,
                programmePrimaryTitle: action.payload,
            }
        }
        case 'DATAENTRY_SET_IS_PROGRAMME_PRIMARY_TITLE_INVALID': {
            return {
                ...state,
                isPrimaryTitleInvalid: action.payload,
            }
        }
        case 'DATAENTRY_EPISODELIST_START_EDITING':
            return {
                ...state,
                episodeListEditRowCount: state.episodeListEditRowCount + 1,
            }
        case 'DATAENTRY_EPISODELIST_STOP_EDITING':
            return {
                ...state,
                episodeListEditRowCount: state.episodeListEditRowCount - 1,
            }
        case 'DATAENTRY_CONTRIBUTION_START_EDITING':
            return {
                ...state,
                contributionEditRowCount: state.contributionEditRowCount + 1,
            }
        case 'DATAENTRY_CONTRIBUTION_STOP_EDITING':
            return {
                ...state,
                contributionEditRowCount: Math.max(0, state.contributionEditRowCount - 1),
            }
        case 'DATAENTRY_SET_FILTER':
            return {
                ...state,
                filter: action.payload
            }
        case 'DATAENTRY_SET_SORT':
            return {
                ...state,
                sort: action.payload
            }
        case 'DATAENTRY_SET_REFRESH':
            return {
                ...state,
                refresh: action.payload
            }
        case 'DATAENTRY_SET_EPISODE_LIST_CURRENT_PAGE':
            return { ...state, episodeListCurrentPage: action.payload }
        case 'DATAENTRY_SET_EPISODE_LIST_FIRST':
            return { ...state, episodeListFirst: action.payload }
        case 'DATAENTRY_SET_EPISODE_LIST_ROWS':
            return { ...state, episodeListRows: action.payload }
        case 'DATAENTRY_SET_EPISODE_LIST_TOTAL_PAGES':
            return { ...state, episodeListTotalPages: action.payload }
        case 'DATAENTRY_SET_EPISODE_LIST_FETCH_STATUS':
            return { ...state, episodeListFetchStatus: action.payload }
        case 'DATAENTRY_SET_EPISODE_LIST_PAGE_DATA':
            return { ...state, episodeListPageData: action.payload }
        default:
            return state
    }
}
